//Funções e constantes para formatar os valores monetários
const numUSD = new Intl.NumberFormat(
    "en-US"
)

function numCOL(digits) {
    return new Intl.NumberFormat(
        "pt-BR", {
        minimumFractionDigits: digits
    }
    )
}
function numBRL(digits) {
    return new Intl.NumberFormat(
        "pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: digits
    }
    )
}

function numOther(digits) {
    return new Intl.NumberFormat("en-US", {
        style: 'decimal',
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    })
}

const numARG = new Intl.NumberFormat(
    "de-DE"
)

export const countryConfig = {
    BR: { prefix: "", formatter: numBRL(2) },
    AR: { prefix: "ARS$ ", formatter: numARG },
    CO: { prefix: "COL$ ", formatter: numCOL(2) },
    MX: { prefix: "MXN$ ", formatter: numCOL(2) },
    BO: { prefix: "BOB ", formatter: numCOL(2) },
    CR: { prefix: "CRC₡ ", formatter: numCOL(2) },
    CL: { prefix: "PESO$ ", formatter: numCOL(2) },
    DO: { prefix: "DOP$ ", formatter: numCOL(2) },
    EC: { prefix: "USD$ ", formatter: numCOL(2) },
    EEA: { prefix: "€ ", formatter: numOther(2) },
    PA: { prefix: "PAB$ ", formatter: numOther(2) },
    PE: { prefix: "PEN S/ ", formatter: numOther(2) },
    PY: { prefix: "PYG₲ ", formatter: numOther(2) },
    UY: { prefix: "UYU$ ", formatter: numOther(2) },
    GT: { prefix: "GTQ ", formatter: numOther(2) },
    HN: { prefix: "HNL ", formatter: numOther(2) },
    SV: { prefix: "USD$ ", formatter: numOther(2) },
    CA: { prefix: "CAD$ ", formatter: numOther(2) },
    OT: { prefix: "USD$ ", formatter: numOther(2) },
    AU: { prefix: "AUD$ ", formatter: numOther(2) },
    BD: { prefix: "BDT৳ ", formatter: numOther(2) },
    CG: { prefix: "CDFFC ", formatter: numOther(2) },
    GH: { prefix: "GHS₵ ", formatter: numOther(2) },
    IN: { prefix: "INR₹ ", formatter: numOther(2) },
    ID: { prefix: "IDRRp ", formatter: numOther(2) },
    JP: { prefix: "JPY¥ ", formatter: numOther(0) },
    KE: { prefix: "KESKSh ", formatter: numOther(2) },
    KR: { prefix: "KRW₩ ", formatter: numOther(0) },
    MY: { prefix: "MYRRM ", formatter: numOther(2) },
    MW: { prefix: "MWKMK ", formatter: numOther(2) },
    NG: { prefix: "NGN₦ ", formatter: numOther(2) },
    PK: { prefix: "PKR₨ ", formatter: numOther(2) },
    RW: { prefix: "RWFR ", formatter: numOther(0) },
    SG: { prefix: "SGD$ ", formatter: numOther(2) },
    TH: { prefix: "THB฿ ", formatter: numOther(2) },
    TR: { prefix: "TRY₺ ", formatter: numOther(2) },
    TW: { prefix: "TWDNT$ ", formatter: numOther(2) },
    TZ: { prefix: "TZSTSh ", formatter: numOther(2) },
    UG: { prefix: "UGXUSh ", formatter: numOther(2) },
    VN: { prefix: "VND₫ ", formatter: numOther(0) },
    CM: { prefix: "XAFFCFA ", formatter: numOther(2) },
    BJ: { prefix: "XOFFCFA ", formatter: numOther(2) },
    CI: { prefix: "XOFFCFA ", formatter: numOther(2) },
    SN: { prefix: "XOFFCFA ", formatter: numOther(2) },
    BF: { prefix: "XOFFCFA ", formatter: numOther(2) },
    TG: { prefix: "XOFFCFA ", formatter: numOther(2) },
    ZM: { prefix: "ZMWZK ", formatter: numOther(2) },
    CN: { prefix: "CNY¥ ", formatter: numOther(2) },
    PH: { prefix: "PHP₱ ", formatter: numOther(2) },
    VE: { prefix: "Bs.S ", formatter: numOther(2) },
    US: { prefix: "USD$ ", formatter: numOther(2) },
    GB: { prefix: "GBP£ ", formatter: numOther(2) },
};
// Default configuration
export const defaultConfig = { prefix: "", formatter: numOther(2) };